import { useLocation, useNavigate } from "react-router-dom";
import { AuthContext, AuthContextType, LangContext, LangContextType, LoadingContext, LoadingContextType, ToastContext, ToastContextType, useAsync, useReloadOnOutletSave, useRequiredParams } from "../../../utilities/customHooks";
import LoadingIndicator from "../../../Components/LoadingIndicator";
import ErrorIndicator from "../../../Components/ErrorIndicator";
import { founderStatusUpdateReject, getMemberDetails, growthCoachByapplication, growthCoachOutcomeUpdate, sendMassEmail, updateApplicationStatus, setIpeStatus, createNewProject, gcAssign } from "../../../services/adminService";
import * as T from "../../../utilities/frontendTypes";
import FormGroup from "../../../Components/FormGroup";
import { convertFounderProfileDBStateToUIState } from "../../../utilities/stateConverters";
import { adminRecommendationFormDefition, founderProfileEvaluationFormGroupDefinition, gcRejectFormDefinition, updatedFounderProfileEvaluationFormGroupDefinition, updatedFounderProfileReadinessEvaluationFormGroupDefinition } from "../../../utilities/formDefinitionTemplates";
import { daysAgo, flattenObject, getModifiedCompanyInfoFormDef, returnFounderStatusStrings, returnFounderStatusStringsGC } from "../../../utilities/helperFunctions";
import { useContext, useEffect, useState } from "react";
import CompanyNotes from "../../../Components/AdminNotes";
import { Accordion, AccordionItem, AccordionItemButton, AccordionItemHeading, AccordionItemPanel, AccordionItemState } from "react-accessible-accordion";
import Plus from '../../../assets/Plus.png'
import Minus from '../../../assets/Minus.png'
import Form, { FormDefinition, FormData, FieldDefinition } from "../../../Components/Form/Form";
import moment from "moment";
import Modal from "../../../Components/Modal";
import PdfDownloader from "../../../Components/Form/pdfDisplay";
import Button, { ButtonProp } from "../../../Components/Button";
import { basic_number_validator, basic_text_validator, selection_validator } from "../../../utilities/formFieldValidators";
import { inputClasses } from "../../../Components/Form/InputField";
import { needHelpWithDefinition, profileFormPersonalInfoDefinition, profileFormAdminProgramingEvaluationDefinition } from "../../../utilities/profileFormDefitions";

function MemberDetails () {
  const { logout } = useContext(AuthContext) as AuthContextType;
  const appId = useRequiredParams("memberId");
  const navigate = useNavigate();
  const [html, setHtml] = useState(<></>)
  const [reloadOnOutletSave, setReloadOnOutletSave] = useState(false);
  const [viewPdfName, setViewPdfName] = useState("")
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalHtml, setModalHtml] = useState(<></>)
  const {showLoading, hideLoading} = useContext(LoadingContext) as LoadingContextType;
  const showToast = (useContext(ToastContext) as ToastContextType).showToast;
  const [coachStatus, setCoachStatus] = useState("")

  const rejectForm: FormDefinition = {
    rejectionReason: {
        label: "Please Select Rejection Reason",
        inputType: "dropdownSelect",
        validator: selection_validator,
        additionalData: {
          selectionData: [
            { value: "Hard Criteria", 
              text: "Hard Criteria" 
            },
            { 
              value: "Economic Benefit",
              text: "Economic Benefit" 
            },
            { 
              value: "Revenue Source",
              text: "Revenue Source" 
            },
            { 
              value: "Market Readiness",
              text: "Market Readiness" 
            },
            { 
              value: "IP Ownership",
              text: "IP Ownership" 
            },
            { 
              value: "Commercialization",
              text: "Commercialization" 
            },
            { 
              value: "Job Creation",
              text: "Job Creation" 
            },
            { 
              value: "Team Fit",
              text: "Team Fit" }
          ]
        }
      },
      time: {
        label: "Please add your time spent on this account in hours",
        inputType: "number",
        validator: basic_number_validator,
      },
      notes: {
        label: "Please add a note regarding your decision",
        inputType: "textarea",
        validator: basic_text_validator,
      }
  }

  const updateCoachStatus = async (updatedFormData?: FormData) => {
    let notes = ""
    let time = 0
    let rejectionReason = ""
    if (coachStatus === "Decline") {
        const tempNotes = updatedFormData as any
        notes = tempNotes.notes
        rejectionReason = tempNotes.rejectionReason
        time = tempNotes.time
    }
    if (coachStatus === "No Concerns") {
      const tempNotes = updatedFormData as any
      notes = tempNotes.notes
      time = tempNotes.time
  }
console.log(coachStatus)
  showLoading();
    const res = await growthCoachOutcomeUpdate(appId, coachStatus, time, notes, rejectionReason) 
    hideLoading();
    if (res.success) {
      showToast({
        toastType: "success",
        message: "Growth Coach Outcome Successfully Updated!",
      });
      setIsModalOpen(false)
      navigate("/dashboard")
  } else {
      showToast({
        toastType: "failure",
        message: "Unable to proceed. If Error persists please conteact support",
      });
    }  
  }

  const primaryGcButtonProp: ButtonProp = {
    buttonText: "Submit Assessment",
    actionHandler: updateCoachStatus,
  }


  const noConcernForm: FormDefinition = {
    notes: {
        label: "Please provide a note regarding your decision",
        inputType: "textarea",
        validator: basic_text_validator,
      },
    time: {
        label: "Please add your time spent on this account in hours",
        inputType: "number",
        validator: basic_number_validator,
    }
  }

  const handleCoachDropdownChange = (e: any) => {
    setCoachStatus(e.target.value);
  };
  
  useEffect(() => {
    const gcModalHtml = (
      <div className="">
        {coachStatus === "Decline" ?
        <div className="flex flex-col justify-center items-center w-full">
          <h2 className="mb-8">Submit your Assessment</h2>
          <div className="w-full mb-10">
            <label htmlFor="dopdown">
              <p className="bodyLarger labelMargin">Growth Coach Outcome</p>
              <select 
                id="dropdown" 
                value={coachStatus} 
                onChange={handleCoachDropdownChange}
                className={`${inputClasses} border-cSecondaryGreen border w-full`}
              >
                <option value="" disabled>Select an Outcome:</option>
                <option value="No Concerns">No Concern</option>
                <option value="Decline">Decline</option>
              </select>
            </label>
          </div>
            <Form
              formDefinition={rejectForm}
              formData={null}
              primaryButtonProp={primaryGcButtonProp}
            />
        </div>
        :
        coachStatus === "No Concerns" ?
        <div className="flex flex-col justify-center items-center w-full">
          <h2 className="mb-8">Submit your Assessment</h2>
          <div className="w-full mb-10">
            <label htmlFor="dopdown">
              <p className="bodyLarger labelMargin">Growth Coach Outcome</p>
              <select 
                id="dropdown" 
                value={coachStatus} 
                onChange={handleCoachDropdownChange}
                className={`${inputClasses} border-cSecondaryGreen border w-full`}
              >
                <option value="" disabled>Select an Outcome:</option>
                <option value="No Concerns">No Concern</option>
                <option value="Decline">Decline</option>
              </select>
            </label>
          </div>
            <Form
              formDefinition={noConcernForm}
              formData={null}
              primaryButtonProp={primaryGcButtonProp}
            />
        </div>        
        :
          <div className="flex flex-col justify-center items-center w-full">
            <h2 className="mb-8">Submit your Assessment</h2>
            <div className="w-full mb-8">
              <label htmlFor="dropdown" className="bodyLarger labelMargin">
                <select 
                  id="dropdown" 
                  value={coachStatus} 
                  onChange={handleCoachDropdownChange}
                  className={`${inputClasses} border-cSecondaryGreen border w-full`}
                >
                  <option value="" disabled>Select an Outcome:</option>
                  <option value="No Concerns">No Concern</option>
                  <option value="Decline">Decline</option>
                </select>
              </label>
            </div>
            {/* <Button
              buttonText="Submit Assessment"
              buttonType="primaryFull"
              actionHandler={() => updateCoachStatus()}
              disabled={coachStatus === "" ? true : false}
            /> */}
          </div>
        }
      </div>
    )
    setModalHtml(gcModalHtml);
  }, [coachStatus]);
  
  useEffect(() => {
    setHtml(<CompanyNotes id={appId}/>)
  }, [appId]);
  
  const [childClickedAccordionItemIndex, setChildClickedAccordionItemIndex] = useState(0);
  const memberDetailsAsync = useAsync(() => getMemberDetails(appId), [reloadOnOutletSave]);

  if (memberDetailsAsync.status === "pending") {
    return <LoadingIndicator />;
  }

  if (memberDetailsAsync.status === "rejected") {
    return <ErrorIndicator />;
  }

  const memberDetails = memberDetailsAsync.value.memberDetails
  const applicationDetails = memberDetailsAsync.value.applicationDetails
  const requestSowFormDefinition: FormDefinition = {
    firm: {
      label: "Select Service Provider Firm",
      frLabel: "Sélectionner Organisation/Admin",
      inputType: "dropdownSelect",
      validator: {
        required: {
          value: true,
          message: "Please select an option"
        }
      },
      additionalData: {
        selectionData:  memberDetailsAsync.value.providersArray
      }
    },
    tier: {
      label: "Select Service Tier",
      inputType: "dropdownSelect",
      validator: {
        required: {
          value: true,
          message: "Please select an option"
        }
      },
      additionalData: {
        selectionData: [
          {
            value: "2",
            text: "2",
          },
          {
            value: "3",
            text: "3",
          },
          {
            value: "2 and 3",
            text: "Both 2 and 3",
          }
        ]
      }
    },
    requestNotes: {
      label: "Notes for Service Provider",
      inputType: "textarea",
      validator: basic_text_validator
    }
  }

  let founderProfileGroupData = null
  if (applicationDetails) {
  founderProfileGroupData = convertFounderProfileDBStateToUIState(applicationDetails.profileSnapshot)
  }
  const isUrl = applicationDetails?.profileSnapshot.companyInfo?.basicInfo?.websiteURL.includes("www.")
  const isHttpsUrl =  applicationDetails?.profileSnapshot.companyInfo?.basicInfo?.websiteURL.includes("https://")
  const urlHref = `https://${applicationDetails?.profileSnapshot.companyInfo?.basicInfo?.websiteURL}`
  const websiteHtml = isHttpsUrl ? <a className="underline font-normal mb-2" href={applicationDetails?.profileSnapshot.companyInfo?.basicInfo?.websiteURL} target="_blank">{applicationDetails?.profileSnapshot.companyInfo?.basicInfo?.websiteURL}</a> : isUrl ? <a className="underline font-normal mb-2" href={urlHref} target="_blank">{applicationDetails?.profileSnapshot.companyInfo?.basicInfo?.websiteURL}</a> : <p className={``}>{applicationDetails?.profileSnapshot.companyInfo?.basicInfo?.websiteURL}</p>      
  let founderStatus = "n/a" 
  let statusStrings = ["Predates Update", "", "Action items not tracked on portal", ""]
  if (applicationDetails && applicationDetails.status) {
    if (applicationDetails.status === "growthCoachRecommendation") {
      statusStrings = returnFounderStatusStrings(applicationDetails.status, applicationDetails.growthCoach?.status)
    } else {
      statusStrings = returnFounderStatusStringsGC(applicationDetails.status)
    }
    founderStatus = applicationDetails.status
  }

  let applicationDate = null
  if (applicationDetails && applicationDetails?.createdAt) {
    applicationDate = applicationDetails.createdAt
  }
  let gcString = "N/A"
  if (applicationDetails?.growthCoach?.status) {
    gcString = applicationDetails.growthCoach.status
  }
  let ipeString = "N/A"
  if (applicationDetails && applicationDetails.expertAssessment && applicationDetails.expertAssessment.assessorName && memberDetailsAsync.value.ipeName) {
    ipeString = memberDetailsAsync.value.ipeName
  }
  let ownerString = "N/A"
  if (memberDetailsAsync.value.owner && memberDetailsAsync.value.owner.ownerName) {
    ownerString = memberDetailsAsync.value.owner.ownerName
  }

  let cohort = 0
  if (memberDetails.cohort) {
    cohort = memberDetails.cohort
  }

  const viewPdf = (pdfName: string) => {
    const pdfModalHtml = <div className="flex w-full min-w-full">
    <PdfDownloader docKey={pdfName}/>
  </div>
    setModalHtml(pdfModalHtml)
    setViewPdfName(pdfName)
    setIsModalOpen(true)
  }


  const simplifyDocString = (docType: string ) => {
    if (docType.includes("Pitch Deck")) {
      return `${applicationDetails?.profileSnapshot.companyInfo?.basicInfo?.operatingName} Pitch Deck`
    }
}

  let docHtml = <></>

  //OLD DOC RETREIVAL WILL NEED TO UPDATE FOR MORE DOCS ON APP I THINK
  if (applicationDetails && applicationDetails.profileSnapshot.documents) {
    const docs = applicationDetails.profileSnapshot.documents as {[key: string]: string;}
    if (docs && docs._id) {
      delete docs._id;
    }
    docHtml =
    <div className="w-full flex flex-col">
    {Object.keys(docs).map((key) => (
        <button key={key} className="flex mt-2 items-center hover:underline" onClick={() => viewPdf(docs[key])}>
          <svg xmlns="http://www.w3.org/2000/svg" className="mr-2" width="13" height="16" viewBox="0 0 13 16" fill="none"><path d="M12.1253 4.96448V4.85029C12.1253 4.85029 12.1253 4.80514 12.1022 4.80514L12.0341 4.73698L6.36849 0.0230173H6.34547C6.34547 0.0230173 6.32245 0.0230174 6.30032 0H2.71948C1.22341 0 0 1.22341 0 2.71948V13.2805C0 14.7766 1.22341 16 2.71948 16H9.51819C11.0143 16 12.2377 14.7766 12.2377 13.2805V5.07693L12.1253 4.96448ZM6.45967 1.31547L10.4256 4.60151H7.13954C6.75445 4.60151 6.45967 4.30673 6.45967 3.92164V1.31547ZM9.40578 14.9811H2.60707C1.61028 14.9811 0.794081 14.1649 0.794081 13.1681V2.60703C0.794081 1.61025 1.61028 0.794045 2.60707 0.794045H5.55318V3.92164C5.55318 4.80511 6.25607 5.508 7.13954 5.508H11.2188V13.1681C11.2188 14.1649 10.4026 14.9811 9.40578 14.9811Z" fill="#1A2E25"/></svg>
          {simplifyDocString(docs[key])}
        </button>
    ))}
    </div>
  }

  const modalClose = () => {
    setIsModalOpen(false)
    setCoachStatus("")
    setViewPdfName("")
  }

  //GC LOGIC

  const performGcAssessment = () => {
    setViewPdfName("")
    setIsModalOpen(true)
  }

  const assignGc = async () => {
    showLoading();
    const res = await gcAssign(appId) 
    hideLoading();
    if (res.success) {
      showToast({
        toastType: "success",
        message: "Growth Coach successfully assigned!",
      });
      setIsModalOpen(false)
      setReloadOnOutletSave(!reloadOnOutletSave)
  } else {
      showToast({
        toastType: "failure",
        message: "Unable to proceed. If Error persists please conteact support",
      });
    }  
  }
  
  //GC ASSESSMENT LOGIC

  const handleRejectApplication = async (reasonNoteForm: {reasonNote: string}) => {
    const reasonNote = reasonNoteForm.reasonNote
    if (applicationDetails) {
      console.log(applicationDetails._id)
      showLoading();
      const res = await updateApplicationStatus(applicationDetails._id, reasonNote, "rejected", false, "membership");
      hideLoading();
      if (res.success) {
        showToast({
          toastType: "success",
          message: `Application has been Rejected`,
        });
        setIsModalOpen(false)
        setReloadOnOutletSave(!reloadOnOutletSave)
      } else {
        setIsModalOpen(false)
        showToast({
          toastType: "failure",
          message: `Unable to reject application at this time.  Please try again, and if the issue persists, contact support`,
        });
      }
    }
  }

  const primaryRejectButtonProp: ButtonProp = {
    buttonText: "Send",
    actionHandler: handleRejectApplication,
  }
  const memberName = applicationDetails?.profileSnapshot.personalInfo ? ` ${applicationDetails?.profileSnapshot.personalInfo?.firstName} ${applicationDetails?.profileSnapshot.personalInfo?.lastName},` : ","
  const companyName = applicationDetails?.profileSnapshot.companyInfo?.basicInfo?.operatingName ? `${applicationDetails?.profileSnapshot.companyInfo.basicInfo.operatingName}` : "this company"
  const rejectionModalHtml = (
    <div className="flex flex-col rejectionModal">
    <h1 className="mb-6">Tier 1 Only</h1>
    <p className="mb-6 font-semibold">You are rejecting {companyName} from moving forward in the application process.</p>
    <p className=" mb-6">Hello{memberName}</p>
    <p className=" mb-6">Thank you for your application to the ElevateIP program. We regret to inform you that you are not eligible for Tier 2 or 3 funded services (IP Development and Implementation) at this time.</p>
    <p className="mb-2">Please provide an explanation for the rejection.</p>
    <Form 
        formDefinition={gcRejectFormDefinition}
        formData={null}
        primaryButtonProp={primaryRejectButtonProp}
      />
    <p className="mb-6 mt-6">However, you are eligible for our free Tier 1 IP Education services. Please visit your portal to make the most of those resources.</p>
    <p className=" mb-6">You’re welcome to respond with any questions or concerns.</p>
    <p className=" mb-6">Kindly,</p>
    <p className="">ElevateIP Team,</p>
    <p className="underline">www.elevateip.ca</p>
    <p className="underline">elevateip@communitech.ca</p>
  </div>
  )

  const handleReject = () => {
    setModalHtml(rejectionModalHtml)
    setIsModalOpen(true)
  }

  const confirmGcModalHtml = (
    <div className="w-full flex flex-col">
      <h1 className="mb-6">Growth Coach Review</h1>
      <p className="bodyLarger font-semibold mb-6">
        You are authorizing a Growth Coach review for {applicationDetails?.profileSnapshot.companyInfo?.basicInfo?.operatingName}. By confirming, this applicant will be added to the list of companies to review.
      </p>
      <Button 
        buttonText="Confirm"
        actionHandler={() => handleGrowthCoach()}
      />
    </div>
  )

  const handleGrowthCoachModal = () => {
    setModalHtml(confirmGcModalHtml)
    setIsModalOpen(true)
  }
  
  //SCREENED LOGIC
  const handleGrowthCoach = async () => {
    if (applicationDetails) {
    showLoading();
    const res = await growthCoachByapplication(applicationDetails._id)
    hideLoading();
    if (res.success) {
      showToast({
        toastType: "success",
        message: "Status Updated",
      });

    } else {
      showToast({
        toastType: "failure",
        message: "Unable to update Statuses, lease try again.  If Error persists please conteact support",
      });
    }
  }}
  //IPE LOGIC

  const confirmIpeModalHtml = (
    <div className="w-full flex flex-col">
      <h1 className="mb-6">IP Expert Assessment</h1>
      <p className="bodyLarger font-semibold mb-2">
      You are authorizing an IP Expert invitation for {applicationDetails?.profileSnapshot.companyInfo?.basicInfo?.operatingName}. By confirming, this applicant will be added to the list of companies to invite.
      </p>
      <p className="mb-6">Please note: the invitation will not be sent with this button. Use the "bulk email" feature for this.</p>
      <Button 
        buttonText="Confirm"
        actionHandler={() => navigate("/dashboard/admin-expert-preinvite")}
      />
    </div>
  )

  const handleIpeModal = () => {
    setModalHtml(confirmIpeModalHtml)
    setIsModalOpen(true)
  }

  const companyInfoToForm = (info: T.CompanyInfo) => {
    return flattenObject({basicInfo: info.basicInfo, registration: info.registration})
  }

  const getNeedHelpFormDef = (founderProfile: T.StartupFounderProfile, regionalFirmOptions: {value: string, text: string}[]) => {
    const regionalFirmSelectionData = () => {
      const array: {value: string, text: string}[] = []
      regionalFirmOptions.forEach((item) => (
        array.push(
          {value: item.value, 
          text: item.text, 
          }
        )
      ))
      array.push({value: "Other", text: "Other"})
      return array
    }
    
    let modifiedForm = { ...needHelpWithDefinition };
    if (founderProfile && founderProfile.needHelpWith && founderProfile.needHelpWith.businessGoal && founderProfile.needHelpWith.topics) {
      const newKey = "topics";
      const newValue: FieldDefinition = {
          label: "Please select the topics that you'd like to discuss with our IP Advisor:",
          frLabel: "",
          inputType: "multiSelect",
          validator: selection_validator,
          conditionalRenderDefinition: {
            fieldKey: "businessGoal",
            renderWhenTrue: true, 
          },
          additionalData: {
            selectionData: [
              {
                value: "Patents",
                text: "Patents",
                frText: "",
              },
              {
                value: "Industrial Designs/ Design Patents",
                text: "Industrial Designs/ Design Patents",
                frText: "",
              },
              {
                value: "Trademarks",
                text: "Trademarks",
                frText: "",
              },
              {
                value: "Trade Secrets",
                text: "Trade Secrets",
                frText: "",
              },
              {
                value: "Copyright",
                text: "Copyright",
                frText: "",
              },
              {
                value: "Open Source Asset Use",
                text: "Open Source Asset Use",
                frText: "",
              },
              {
                value: "IP Strategy",
                text: "IP Strategy",
                frText: "",
              },
              {
                value: "IP Ownership",
                text: "IP Ownership",
                frText: "",
              },
              {
                value: "Freedom to Operate",
                text: "Freedom to Operate",
                frText: "",
              },
            ]
          },
      };
  
      const newForm: FormDefinition = {};
      for (const [key, value] of Object.entries(modifiedForm)) {
        newForm[key] = value;
        if (key === "businessGoal") {
          newForm[newKey] = newValue;
        }
      }
      modifiedForm = newForm;
    }
    if (founderProfile && founderProfile.needHelpWith && founderProfile.needHelpWith.businessGoal && founderProfile.needHelpWith.topics) {
      const newKey = "specificDiscussion";
      const newValue: FieldDefinition = {
        label: "Without specifically referencing IP sensitive information, please provide a general overview of what you' like to discuss with our IP Advisor",
        frLabel: "",
        inputType: "textarea",
        conditionalRenderDefinition: {
          fieldKey: "businessGoal",
          renderWhenTrue: true, 
        },
        validator: basic_text_validator
      };
  
      const newForm: FormDefinition = {};
      for (const [key, value] of Object.entries(modifiedForm)) {
        newForm[key] = value;
        if (key === "topics") {
          newForm[newKey] = newValue;
        }
      }
      modifiedForm = newForm;
    }

    if (founderProfile && founderProfile.needHelpWith && founderProfile.needHelpWith.desiredActivities.includes("Other")) {
      const newKey = "activitiesOther";
      const newValue: FieldDefinition = {
        label: "Please specify",
        frLabel: "Veuillez préciser",
        inputType: "text",
        validator: basic_text_validator
      };
  
      const newForm: FormDefinition = {};
      for (const [key, value] of Object.entries(modifiedForm)) {
        newForm[key] = value;
        if (key === "desiredActivities") {
          newForm[newKey] = newValue;
        }
      }
      modifiedForm = newForm;
    }

    if (founderProfile && founderProfile.needHelpWith && founderProfile.needHelpWith.patentActivities.includes("Other")) {
      const newKey = "patentActivitiesOther";
      const newValue: FieldDefinition = {
        label: "Please specify",
        frLabel: "Veuillez préciser",
        inputType: "text",
        validator: basic_text_validator  
      };
  
      const newForm: FormDefinition = {};
      for (const [key, value] of Object.entries(modifiedForm)) {
        newForm[key] = value;
        if (key === "patentActivities") {
          newForm[newKey] = newValue;
        }
      }
      modifiedForm = newForm;
    }

    if (founderProfile && founderProfile.needHelpWith && founderProfile.needHelpWith.patentActivities.length > 0 && founderProfile.needHelpWith.searchCompleted) {
      const newKey = "searchCompleted";
      const newValue: FieldDefinition = {
        label: "If you think you are ready to register trademarks in the next 3-6 months, has your IP service provider completed a clearance search?",
        frLabel: "If you think you are ready to register trademarks in the next 3-6 months, has your IP service provider completed a clearance search?",
        inputType: "dropdownSelect",
        validator: selection_validator,
        additionalData: {
          selectionData: [
            {
              value: "yes",
              text: "Yes",
              frText: "Oui",
            },
            {
              value: "no",
              text: "No",
              frText: "Non",
            },
            {
              value: "n/a",
              text: "N/A",
              frText: "N/A",
            }
          ]
        },     
      };
  
      const newForm: FormDefinition = {};
      for (const [key, value] of Object.entries(modifiedForm)) {
        newForm[key] = value;
        if (key === "patentActivities") {
          newForm[newKey] = newValue;
        }
      }
      modifiedForm = newForm;
    }

    if (founderProfile && founderProfile.needHelpWith && founderProfile.needHelpWith.patentActivities.includes("Patent Filing")) {
      const newKey = "patentsReadyOptions";
      const newValue: FieldDefinition = {
        label: "If you think you are ready to file patents in the next 3-6 months, please indicate which of the following apply to the technology you intend to patent:",
        frLabel: "",
        inputType: "multiSelect",
        validator: selection_validator,
        additionalData: {
          selectionData: [
            {
              value: "My IP service provider has conducted a favorable patentability/prior art/novelty search for the technology I plan to patent.",
              text: "My IP service provider has conducted a favorable patentability/prior art/novelty search for the technology I plan to patent.",
              frText: "",
            },
            {
              value: "I have a granted patent in the same patent family.",
              text: "I have a granted patent in the same patent family.",
              frText: "",
            },
            {
              value: "I have received a favorable written opinion from my PCT application.",
              text: "I have received a favorable written opinion from my PCT application.",
              frText: "",
            },
            {
              value: "None of the Above",
              text: "None of the Above",
              frText: "",
            }
          ]
        },
      };
        const newForm: FormDefinition = {};
        for (const [key, value] of Object.entries(modifiedForm)) {
          newForm[key] = value;
          if (key === "patentActivities") {
            newForm[newKey] = newValue;
          }
        }
        modifiedForm = newForm;
      }

      if (founderProfile && founderProfile.needHelpWith && founderProfile.needHelpWith.patentActivities.length > 0 && founderProfile.needHelpWith.exclusiveRights) {
        const newKey = "exclusiveRights";
        const newValue: FieldDefinition = {
          label: "If you think you are ready to register trademarks in the next 3-6 months, has your IP service provider completed a clearance search?",
          frLabel: "If you think you are ready to register trademarks in the next 3-6 months, has your IP service provider completed a clearance search?",
          inputType: "dropdownSelect",
          validator: selection_validator,
          additionalData: {
            selectionData: [
              {
                value: "yes",
                text: "Yes",
                frText: "Oui",
              },
              {
                value: "no",
                text: "No",
                frText: "Non",
              },
              {
                value: "n/a",
                text: "N/A",
                frText: "N/A",
              }
            ]
          },     
        };
    
        const newForm: FormDefinition = {};
        for (const [key, value] of Object.entries(modifiedForm)) {
          newForm[key] = value;
          if (key === "patentActivities") {
            newForm[newKey] = newValue;
          }
        }
        modifiedForm = newForm;
      }
  
      if (founderProfile && founderProfile.needHelpWith && founderProfile.needHelpWith.patentActivities.includes("Trademark Filing")) {
        const newKey = "searchCompleted";
        const newValue: FieldDefinition = {
          label: "If you think you are ready to register trademarks in the next 3-6 months, has your IP service provider completed a clearance search?",
          frLabel: "If you think you are ready to register trademarks in the next 3-6 months, has your IP service provider completed a clearance search?",
          inputType: "dropdownSelect",
          validator: selection_validator,
          additionalData: {
            selectionData: [
              {
                value: "yes",
                text: "Yes",
                frText: "Oui",
              },
              {
                value: "no",
                text: "No",
                frText: "Non",
              },
              {
                value: "n/a",
                text: "N/A",
                frText: "N/A",
              }
            ]
          },     
        };
    
        const newForm: FormDefinition = {};
        for (const [key, value] of Object.entries(modifiedForm)) {
          newForm[key] = value;
          if (key === "patentActivities") {
            newForm[newKey] = newValue;
          }
        }
        modifiedForm = newForm;
      }
        if (founderProfile && founderProfile.needHelpWith && founderProfile.needHelpWith.workingWithFirm) {
        const newKey = "firmId";
        const newValue: FieldDefinition = {
          label: `Please select the firm (select "Other" if your current firm is not listed)`,
          frLabel: "",
          inputType: "dropdownSelect",
          validator: selection_validator,
          additionalData: {
            selectionData: regionalFirmSelectionData()
          },
          };
    
        const newForm: FormDefinition = {};
        for (const [key, value] of Object.entries(modifiedForm)) {
          newForm[key] = value;
          if (key === "workingWithFirm") {
            newForm[newKey] = newValue;
          }
        }
        modifiedForm = newForm;
      }

      if (founderProfile && founderProfile.needHelpWith && founderProfile.needHelpWith.workingWithFirm && founderProfile.needHelpWith.firmId === "Other" && founderProfile.needHelpWith.firmOther) {
        const newKey = "firmOther";
        const newValue: FieldDefinition = {
          label: "Please specify",
          frLabel: "Veuillez préciser",
          inputType: "text",
          validator: basic_text_validator    
        };
    
        const newForm: FormDefinition = {};
        for (const [key, value] of Object.entries(modifiedForm)) {
          newForm[key] = value;
          if (key === "firmId") {
            newForm[newKey] = newValue;
          }
        }
        modifiedForm = newForm;
      }

      if (founderProfile && founderProfile.needHelpWith && founderProfile.needHelpWith.govtSupport) {
        const newKey = "supportOrg";
        const newValue: FieldDefinition = {
          label: `Please select which organization:`,
          frLabel: "Veuillez préciser quelle organisation:",
          inputType: "dropdownSelect",
          validator: selection_validator,
          additionalData: {
            selectionData: [
              {
                value: "Intellectual Property Ontario (IPON)",
                text: "Intellectual Property Ontario (IPON)",
                frText: "",
              },
              {
                value: "IP Assist",
                text: "IP Assist",
                frText: "",
              },
              {
                value: "Other",
                text: "Other",
                frText: "",
              }
            ]
          },     
        };
    
        const newForm: FormDefinition = {};
        for (const [key, value] of Object.entries(modifiedForm)) {
          newForm[key] = value;
          if (key === "govtSupport") {
            newForm[newKey] = newValue;
          }
        }
        modifiedForm = newForm;
      }

      if (founderProfile && founderProfile.needHelpWith && founderProfile.needHelpWith.govtSupport && founderProfile.needHelpWith.supportOrg === "Other" && founderProfile.needHelpWith.supportOrgOther) {
        const newKey = "supportOrgOther";
        const newValue: FieldDefinition = {
          label: "Please specify",
          frLabel: "Veuillez préciser",
          inputType: "text",
          validator: basic_text_validator        
        };
    
        const newForm: FormDefinition = {};
        for (const [key, value] of Object.entries(modifiedForm)) {
          newForm[key] = value;
          if (key === "supportOrg") {
            newForm[newKey] = newValue;
          }
        }
        modifiedForm = newForm;
      }

    return modifiedForm
  }


  const bnNumLink = document.querySelector('a[href="https://www.canada.ca/en/revenue-agency/services/tax/businesses/topics/registering-your-business/you-need-a-business-number-a-program-account.html"]');
  if (bnNumLink) {
    bnNumLink.classList.add('underline');
  }

  return (
    <div className="resourcesCont !pt-0 !gap-0">
      <h2 className="mb-8">{applicationDetails?.profileSnapshot.companyInfo?.basicInfo?.operatingName ? applicationDetails?.profileSnapshot.companyInfo?.basicInfo?.operatingName : memberDetails.username}</h2>
      <div className="w-full flex justify-between switchFlex">
        <div className="memDetailsCont1">
          <div>
            <div className="flex flex-col mb-4">
            {applicationDetails?.profileSnapshot.companyInfo?.basicInfo ?
            <div>
              {websiteHtml}
              <p className="">{applicationDetails?.profileSnapshot.companyInfo?.basicInfo?.description}</p>
            </div>
            :
            <p>Startup has not completed Company Information</p>
            }
            </div>
            { 
            applicationDetails?.profileSnapshot.personalInfo ?
            <div className="flex flex-col gap-2">
              <p className="bodyLarger font-semibold">{`${applicationDetails?.profileSnapshot.personalInfo?.firstName} ${applicationDetails?.profileSnapshot.personalInfo?.lastName} `}<span className="font-normal">{`(${applicationDetails?.profileSnapshot.personalInfo?.pronouns})`}</span></p>
              <p className="">{applicationDetails?.profileSnapshot.personalInfo.title}</p>
              <p className=" flex items-center">
                <svg xmlns="http://www.w3.org/2000/svg" className="mr-2" width="15" height="14" viewBox="0 0 15 14" fill="none"><path d="M0.976621 0.000509719C0.700221 0.00156869 0.459824 0.129712 0.282949 0.304455C0.108208 0.54168 -0.00510934 0.777847 0.000177378 1.00873C0.139969 5.09143 1.42987 8.35727 3.76188 10.591C6.09707 12.8277 9.45311 14.0076 13.6491 14C13.9192 13.9629 14.1808 13.8464 14.3481 13.6854C14.525 13.5107 14.6616 13.2745 14.6626 12.997C14.6701 12.0248 14.6775 11.0505 14.6838 10.0782C14.6764 9.80605 14.5419 9.58048 14.364 9.41103C14.1861 9.24159 13.9478 9.11558 13.6703 9.11769C12.7564 9.12087 11.5342 8.80209 10.5493 8.55746C10.437 8.52887 10.312 8.56275 10.2294 8.64324L8.50107 10.3186C6.39782 9.06792 5.4795 8.17622 4.19497 6.13536L5.91272 4.47056C5.99956 4.38583 6.03556 4.25134 6.0038 4.13484C5.74115 3.15099 5.28895 1.84097 5.36307 0.869812C5.3493 0.60611 5.12267 0.369932 4.95217 0.240747C4.77213 0.10625 4.53384 -0.00706801 4.25321 0.000344244H0.977615L0.976621 0.000509719ZM0.976621 0.683581H4.26822C4.34447 0.680404 4.44719 0.720648 4.54039 0.790544C4.62299 0.851967 4.67488 0.928218 4.68971 0.950458C4.64205 2.05609 5.03706 3.23164 5.287 4.12005L3.51522 5.84311C3.40296 5.95008 3.37966 6.13857 3.46227 6.2699C4.91422 8.62415 5.9563 9.63334 8.3762 11.045C8.50329 11.1202 8.68015 11.1001 8.78711 10.9974L10.5695 9.26374C11.5152 9.50202 12.6664 9.80702 13.6745 9.80279C13.7285 9.80279 13.8217 9.83668 13.8938 9.90446C13.9647 9.97224 13.9997 10.0612 14.0007 10.0961L13.9795 12.9938C13.9795 13.0372 13.9456 13.1294 13.8726 13.2014C13.7995 13.2734 13.6936 13.3147 13.6269 13.3189C9.57074 13.3221 6.41795 12.1868 4.2363 10.0962C2.05044 8.00141 0.814572 4.92715 0.683353 0.967256C0.68653 0.888888 0.740542 0.838053 0.769136 0.791454C0.825265 0.727911 0.912105 0.710966 0.976709 0.684492L0.976621 0.683581Z" fill="#1A2E25"/></svg>
                {applicationDetails?.profileSnapshot.personalInfo.phoneNumber}
              </p>
              <p className=" flex items-center">
                <svg xmlns="http://www.w3.org/2000/svg" className="mr-2" width="21" height="14" viewBox="0 0 21 14" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.643217 0.98439C2.48353 2.62505 4.23794 4.12706 5.56312 5.24541C6.28 5.84952 6.87069 6.34091 7.28344 6.68229C7.43758 6.81057 7.56688 6.91712 7.66826 6.99987C4.25759 9.80223 3.87174 10.1457 0.780714 12.8954C0.735196 12.9357 0.688645 12.9761 0.64313 13.0174C0.582096 10.1012 0.552096 8.55066 0.552096 6.99985C0.552096 5.44904 0.582183 3.89957 0.643217 0.98439ZM1.09424 13.3546C5.59016 13.4167 7.9508 13.4477 10.3104 13.4477C12.6741 13.4477 15.038 13.4167 19.5482 13.3546C16.3672 10.4095 16.03 10.1115 12.5262 7.35765L11.2186 8.5028C10.6983 8.95798 9.92241 8.95798 9.40206 8.5028L8.09759 7.36178C4.62283 10.2168 4.2587 10.5407 1.1502 13.3047C1.13158 13.3212 1.11286 13.338 1.09424 13.3546ZM8.27766 6.78573C8.28076 6.7878 8.28283 6.78987 8.2849 6.79194L9.76521 8.08709C10.0776 8.36018 10.5431 8.36018 10.8555 8.08709L12.3359 6.79194C12.3379 6.78987 12.341 6.7878 12.3441 6.78573L12.3772 6.75884C12.399 6.74022 12.4321 6.71332 12.4765 6.67712C12.5645 6.6047 12.6969 6.49712 12.8696 6.35435C13.2162 6.06781 13.7283 5.6416 14.3914 5.08195C15.6172 4.04643 17.3603 2.5537 19.5244 0.645087C15.0296 0.583018 12.67 0.551985 10.3104 0.551985C7.94975 0.551985 5.58913 0.58302 1.09136 0.645087C2.89858 2.25368 4.61591 3.72473 5.9191 4.82322C6.63392 5.4263 7.22358 5.91665 7.6353 6.257C7.84012 6.42665 8.0015 6.55906 8.11116 6.64907C8.16495 6.69355 8.20736 6.72872 8.23529 6.75148L8.27766 6.78573ZM19.9775 0.980417C17.77 2.9304 15.9927 4.452 14.7472 5.50414C14.0821 6.06483 13.569 6.49207 13.2214 6.77964C13.119 6.86343 13.0311 6.93584 12.9586 6.99584C16.4106 9.71029 16.7634 10.0249 19.9786 13.001C20.0386 10.0951 20.0686 8.54771 20.0686 7.00008C20.0686 5.44941 20.0385 3.89745 19.9775 0.980417ZM0.375242 0.103188C10.3093 -0.034396 10.3114 -0.034396 20.2452 0.103188C20.3932 0.105257 20.5142 0.225256 20.5173 0.373176C20.6549 6.99801 20.6549 7.00199 20.5173 13.6268C20.5142 13.7748 20.3932 13.8947 20.2452 13.8968C10.3112 14.0344 10.3091 14.0344 0.375242 13.8968C0.227314 13.8947 0.106286 13.7747 0.103188 13.6268C-0.034396 7.00199 -0.034396 6.99801 0.103188 0.373176C0.106291 0.225248 0.227324 0.105254 0.375242 0.103188Z" fill="#1A2E25"/></svg>
                {memberDetails.email}
              </p>
            </div>
            :
            <p>Startup has not completed Personal Information</p>
            }
          </div>
          <Accordion
              allowZeroExpanded={true}
              className="w-full overflow-y-auto"
              >    
              <AccordionItem
                  uuid={0}
                  className=""
                  key={`0`}
                  onClick={() => setChildClickedAccordionItemIndex(0)}
                  >
                  <AccordionItemHeading>
                    <AccordionItemButton className="flex memDetailsAccButt items-center py-4 justify-between border-b border-cSage">
                      <p className="font-semibold bodyLarger">Scoring</p>
                      <AccordionItemState>
                      {({ expanded }) => (expanded ? <img src={Minus} alt="collapse"/> : <img src={Plus} alt="expand"/>)}
                      </AccordionItemState>
                    </AccordionItemButton>
                  </AccordionItemHeading>
                  <AccordionItemPanel>
                    {applicationDetails && applicationDetails.ipPreScore && applicationDetails.applicationScore &&
                    <h4 className="font-semibold mt-4">Total Score: {applicationDetails.ipPreScore.totalScore + applicationDetails.applicationScore.totalScore}</h4>
                    }
                    {applicationDetails && applicationDetails.ipPreScore === undefined && applicationDetails.applicationScore &&
                    <h4 className="font-semibold mt-4">Total Score: {applicationDetails.applicationScore.totalScore}</h4>
                    }
                    <div className="flex flex-col w-full mt-4">
                      <p className="text-xl bodyLarger font-semibold">Persona Score: {applicationDetails?.applicationScore?.totalScore}</p>
                      <ul className="ml-2 list-disc">
                        <li>Classification: {applicationDetails?.applicationScore?.classification}</li>
                        <li>Age Score: {applicationDetails?.applicationScore?.age}</li>
                        <li>Revenue Score: {applicationDetails?.applicationScore?.revenue}</li>
                        <li>Employee Score: {applicationDetails?.applicationScore?.fte}</li>
                      </ul>
                    </div>
                    {
                    applicationDetails?.ipPreScore &&
                    <div className="flex flex-col w-full mt-4">
                      <p className="bodyLarger font-semibold">IP PreScore: {applicationDetails?.ipPreScore?.totalScore}</p>
                      <ul className="ml-2 list-disc">
                        <li>IP Readiness - Patents: {applicationDetails?.ipPreScore?.ipReadinessPatents}</li>
                        <li>IP Readiness - General: {applicationDetails?.ipPreScore?.ipReadinessGeneral}</li>
                      </ul>
                    </div>
                    }
                  </AccordionItemPanel>
                </AccordionItem>
                <AccordionItem
                  uuid={1}
                  className=""
                  key={`1`}
                  onClick={() => setChildClickedAccordionItemIndex(1)}
                  >
                  <AccordionItemHeading>
                      <AccordionItemButton className="flex memDetailsAccButt items-center py-4 justify-between border-b border-cSage">
                        <p className="font-semibold bodyLarger">Program Application</p>
                        <AccordionItemState>
                        {({ expanded }) => (expanded ? <img src={Minus} alt="collapse"/> : <img src={Plus} alt="expand"/>)}
                        </AccordionItemState>
                      </AccordionItemButton>
                    </AccordionItemHeading>
                  <AccordionItemPanel>
                  {applicationDetails ?
                    <div className="mt-4">                  
                    <div className="flex flex-col applicationFormWidth">
                      <h4 className="mb-6">Personal Info</h4>
                      <Form
                        formDefinition={profileFormPersonalInfoDefinition}
                        formData={applicationDetails?.profileSnapshot && applicationDetails?.profileSnapshot.personalInfo ? applicationDetails?.profileSnapshot.personalInfo : null}
                        readOnly
                        disabled
                      />
                      <h4 className="mb-6 mt-8">Company Info</h4>
                      {applicationDetails &&
                        <Form
                        formDefinition={getModifiedCompanyInfoFormDef(applicationDetails.profileSnapshot)}
                        formData={applicationDetails?.profileSnapshot && applicationDetails?.profileSnapshot.companyInfo ? companyInfoToForm(applicationDetails?.profileSnapshot.companyInfo) : null}
                        readOnly
                        disabled
                      />
                      }
                      <h4 className="mb-6 mt-8">Need Help With</h4>
                      {applicationDetails &&
                      <Form
                        formDefinition={getNeedHelpFormDef(applicationDetails.profileSnapshot, memberDetailsAsync.value.providersArray)}
                        formData={applicationDetails?.profileSnapshot && applicationDetails?.profileSnapshot.needHelpWith ? applicationDetails?.profileSnapshot.needHelpWith : null}
                        readOnly
                        disabled
                      />
                      }
                      <h4 className="mb-6 mt-8">Community, Culture & Climate</h4>
                      <Form
                        formDefinition={profileFormAdminProgramingEvaluationDefinition}
                        formData={applicationDetails?.profileSnapshot && applicationDetails?.profileSnapshot.programingEvaluation ? applicationDetails?.profileSnapshot.programingEvaluation : null}
                        readOnly
                        disabled
                      />
                    </div>
                    </div>
                    :
                    <p className="mt-4">No application has been submitted</p>
                    }

                  </AccordionItemPanel>
                </AccordionItem>
              </Accordion>
            {html}
        </div>
        <div className="memDetailsCont2">
          <div className="w-full">
            <div className="flex justify-between w-full gap-2">
              <div className="flex flex-col w-1/2 gap-2">
                <h4 className="font-semibold">Status:</h4>
                <p className="bodyLarger">{statusStrings[0]}</p>
              </div>
              <div className="flex flex-col w-1/2 gap-2">
                <h4 className="font-semibold">Action Item:</h4>
                  {statusStrings[1] 
                  ? 
                  <div className="flex flex-wrap items-center">
                    
                    <p className="bodyLarger break-word flex items-center"><div className={statusStrings[1]}></div>{statusStrings[2]}</p>
                  </div>
                  :
                  <p className="bodyLarger text-cSecondaryGreen">No action required</p>
                  }
        
              </div>
            </div>
            {
              statusStrings[3] && 
              <p className="bodyLarger mt-4">{statusStrings[3]}</p>
            }
            {/* STATUS SPECFIC BUTTONS */}
            {
              founderStatus === "growthCoachInvite" &&
              <div className="w-full mt-8">
                <Button 
                  buttonText="Assign Yourself as Growth Coach"
                  actionHandler={() => assignGc()}
                  buttonType="primaryFull"
                />
              </div>
            }
            {
              founderStatus === "growthCoachInProgress" &&
              <div className="w-full mt-8">
                <Button 
                  buttonText="Perform Growth Coach Assessment"
                  actionHandler={() => performGcAssessment()}
                  buttonType="primaryFull"
                />
              </div>
            }
          </div>
          <div className="memDetailsCont2Inner">
            <div className="flex justify-between w-full">
              <div className="w-1/3 flex flex-col">
                <p className="bodyLarger font-semibold">Application</p>
                {applicationDate !== null ?
                <p>{moment(applicationDate).format('MMM Do YYYY').toString()}</p>
                :
                <p className="">Unsubmitted</p>
                }
              </div>
              <div className="w-1/3 flex flex-col">
                <p className="bodyLarger font-semibold">Touch Point</p>
                {founderStatus === "n/a" ?
                <p className="text-cSecondaryGreen">N/A</p>
                :
                <p className="text-cSecondaryGreen">N/A</p>
                }
              </div>
              <div className="w-1/3 flex flex-col">
                <p className="bodyLarger font-semibold">Status</p>
                <p>{statusStrings[0]}</p>
              </div>
            </div>
            <div className="flex justify-between w-full">
              <div className="w-1/3 flex flex-col">
                <p className="bodyLarger font-semibold">Cohort</p>
                <p>{cohort}</p>
              </div>
              <div className="w-1/3 flex flex-col">
                <p className="bodyLarger font-semibold">Screened</p>
                {applicationDetails && applicationDetails.status === "approved" ?
                <p>Yes</p>
                :
                <p className="">No</p>
                }
              </div>
              <div className="w-1/3 flex flex-col">
                <p className="bodyLarger font-semibold">Due Diligence</p>
                {applicationDetails && applicationDetails.ddObj && applicationDetails.status !== "rejected" && applicationDetails.status !== "rejectedInProgress" ?
                <p className="text-cSecondaryGreen">Complete</p>
                :
                <p className="text-cSecondaryGreen">Incomplete</p>
                }
              </div>
            </div>
            <div className="flex justify-between w-full">
              <div className="w-1/3 flex flex-col">
                <p className="bodyLarger font-semibold">Owner</p>
                <p className={ownerString === "N/A" ? "text-cSecondaryGreen" : ""}>{ownerString}</p>
              </div>
              <div className="w-1/3 flex flex-col">
                <p className="bodyLarger font-semibold">GC</p>
                <p className={gcString === "N/A" ? "text-cSecondaryGreen" : ""}>{gcString}</p>
              </div>
              <div className="w-1/3 flex flex-col">
                <p className="bodyLarger font-semibold">IPE</p>
                <p className={ipeString === "N/A" ? "text-cSecondaryGreen" : ""}>{ipeString}</p>
              </div>
            </div>
            {/* <div className="flex justify-between w-full">
              <div className="w-1/3 flex flex-col">
                <p className="bodyLarger font-semibold">Tier</p>
                <p>AWAITNG SOW</p>
              </div>
              <div className="w-1/3 flex flex-col">
                <p className="bodyLarger font-semibold">SP</p>
                <p>AWAITNG SOW</p>
              </div>
              <div className="w-1/3 flex flex-col">
                <p className="bodyLarger font-semibold">Co-Invest %</p>
                <p>AWAITNG SOW</p>
              </div>
            </div> */}
            <div className="flex flex-col w-full">
              <p className="bodyLarger font-semibold w-full">Files</p>
              {docHtml}
            </div>
          </div>
        </div>
      </div>
      <Modal 
        isOpen={isModalOpen}
        closeModal={() => modalClose()}
        modalHeader={""}
        contentLabel={""} // [TODO]
        fullWidth={true}
        modalHTML={modalHtml}
        style={
          viewPdfName === "" ?
          {content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            minWidth: '300px',
            width: 'fit-content',
            maxWidth: '800px',
            maxHeight: '80%',
            background: "background",
          }}
          :
          {content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            minWidth: '300px',
            width: 'full',
            background: "background",
          }}
        }
        />
    </div>
  )
}

export default MemberDetails